import 'lightgallery.js/dist/js/lightgallery.js';
import 'lightgallery.js/dist/css/lightgallery.css';

export default function () {
  document.querySelectorAll('.lightgallery').forEach(gallery => window.lightGallery(gallery, {
    selector: '.lightgallery__item--button',
  }));
}
